import { useEffect, useState } from 'react';

/** 입력이 멈추고 delay(ms) 뒤에 값을 넘긴다 — 서버 검색어에 쓴다 */
export const useDebouncedValue = <T>(value: T, delay = 300) => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
};
